// Relics - passive effects that persist across combats.

export const RELICS = {
  burnerphone: {
    id: 'burnerphone', name: 'BURNER PHONE',
    desc: 'Start each combat with +1 energy.',
    art: '📱',
  },
  ringlight: {
    id: 'ringlight', name: 'RING LIGHT',
    desc: 'Draw 1 extra card each turn.',
    art: '💡',
  },
  energydrink: {
    id: 'energydrink', name: 'MONSTER CAN',
    desc: 'Start of combat: gain 5 block.',
    art: '🥤',
  },
  cursedcoin: {
    id: 'cursedcoin', name: 'CURSED COIN',
    desc: 'Gain +50% gold from combats.',
    art: '🪙',
  },
  streamdeck: {
    id: 'streamdeck', name: 'STREAM DECK',
    desc: 'Card rewards show 4 options instead of 3.',
    art: '🎛',
  },
  algobreaker: {
    id: 'algobreaker', name: 'ALGO BREAKER',
    desc: 'At start of combat, apply 1 Weak to enemy.',
    art: '🧨',
  },
  // v0.8: relic-set pieces (Streamer Kit)
  microphone: { id: 'microphone', name: 'MICROPHONE', desc: 'Enemies deal -1 dmg per attack.', art: '🎤' },
  greenscreen: { id: 'greenscreen', name: 'GREEN SCREEN', desc: '+15% gold from combats.', art: '🟢' },
  // Gigachad Set
  proteinshake: { id: 'proteinshake', name: 'PROTEIN SHAKE', desc: 'Gain +1 STR at start of combat.', art: '🥛' },
  miogtrophy: { id: 'miogtrophy', name: 'MOG TROPHY', desc: 'On elite kill: +5 max HP.', art: '🏆' },
  flexcam: { id: 'flexcam', name: 'FLEX CAM', desc: '+20% damage vs elites.', art: '📸' },
  // Schizo Meta
  tinfoilhat: { id: 'tinfoilhat', name: 'TIN FOIL HAT', desc: 'Random events give +1 option.', art: '👒' },
  conspiracymap: { id: 'conspiracymap', name: 'CONSPIRACY MAP', desc: 'Reveals boss identity.', art: '🗺' },
  redstring: { id: 'redstring', name: 'RED STRING', desc: '+2 dmg per unique tag played.', art: '🧵' },
  // Extras
  slopjar: { id: 'slopjar', name: 'SLOP JAR', desc: '+3 max HP per fight.', art: '🫙' },
  loreleash: { id: 'loreleash', name: 'LORE LEASH', desc: 'Draw +1 first turn only.', art: '⛓' },

  // v0.9 BOSS/ELITE-TIER RELICS (high-impact)
  cursedcrown: { id: 'cursedcrown', name: 'CURSED CROWN', desc: 'BOSS: +2 STR at start of combat. -3 max HP.', art: '👑', boss: true },
  omeganode: { id: 'omeganode', name: 'OMEGA NODE', desc: 'BOSS: Powers cost 1 less. Once per combat: draw 3.', art: '🌐', boss: true },
  slopmonolith: { id: 'slopmonolith', name: 'SLOP MONOLITH', desc: 'BOSS: Every 3rd card played this turn deals +6 dmg.', art: '🗿', boss: true },
  eldergpu: { id: 'eldergpu', name: 'ELDER GPU', desc: 'ELITE: Turn 1 gives +2 energy.', art: '💻', elite: true },
  chatsummon: { id: 'chatsummon', name: 'CHAT SUMMONER', desc: 'ELITE: Every 5 attacks, gain 2 STR.', art: '📡', elite: true },
  paradoxpouch: { id: 'paradoxpouch', name: 'PARADOX POUCH', desc: 'ELITE: First card each combat is played twice.', art: '👝', elite: true },

  // v1.8 DEPTH: 6 new relics
  streakring: { id: 'streakring', name: 'STREAK RING', desc: 'Start each combat with +1 STR per current run streak (max +5).', art: '💍' },
  gigacoin:   { id: 'gigacoin',   name: 'GIGA COIN',   desc: 'On card reward pick: gain 8 GOLD.', art: '💰' },
  slopfilter: { id: 'slopfilter', name: 'SLOP FILTER', desc: 'First 2 STATUS/CURSE drawn each combat are auto-exhausted.', art: '🕶' },
  aurabank:   { id: 'aurabank',   name: 'AURA BANK',   desc: 'Every 3rd turn: gain +1 energy.', art: '🏦' },
  echoshard:  { id: 'echoshard',  name: 'ECHO SHARD',  desc: 'The first ATTACK you play each combat is played twice.', art: '💎' },
  moglicense: { id: 'moglicense', name: 'MOG LICENSE', desc: 'Killing an enemy in 2 turns or less: +6 max HP (once per combat).', art: '🪪' },
};

export function relicById(id) { return RELICS[id]; }
export const ALL_RELIC_IDS = Object.keys(RELICS);
